import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import Login from './views/login/login';
import Register from './views/register/register';
import Home from './views/home/home';
import { Spinner } from './components/spinner/spinner';
import { urlList } from './components/URLlist/urlList';
import { saveConsoleLog } from './helpFunction/helpFunction';
import Massage, { propsMassage } from './components/massage/massage';
import Bowser from 'bowser';
import mobile from 'mobile-detect';

import { usePWAInstall } from 'react-use-pwa-install';
import PWAPrompt from 'react-ios-pwa-prompt';

export type widok = {
  login?: boolean;
  home?: boolean;
  register?: boolean;
};
export interface props {
  setViews: (widoki: widok) => void;
  setMassage: (e: propsMassage) => void;
  setSpinner: (e: boolean) => void;
  massage?: string;
}
export interface birthdayData {
  id: string;
  nazwisko: string;
  imie: string;
  data_ur: string;
  userID?: string;
  last: number;
  dataLast?: Date;
  createdAt?: string;
  image?: string;
}
function App() {
  const [views, setViews] = useState<widok>({ login: true });
  const [spinner, setSpinner] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState('');
  const [massage, setMassage] = useState<propsMassage>({ text: '', type: 'ok' });
  const warning = useRef<HTMLDivElement>(null);
  const [shouldShowPWAPrompt, setShouldShowPWAPrompt] = useState(false);

  useEffect(() => {
    setTimeout(() => setMassage({}), 2500);
  }, [massage.text]);

  useEffect(() => {
    // 20% chance of popping up
    // setShouldShowPWAPrompt(true);
    setShouldShowPWAPrompt(Math.random() < 0.1);
    const device = new mobile(window.navigator.userAgent);
    setDeviceInfo(device.os());
  }, []);

  useEffect(() => {
    const parser = Bowser.getParser(navigator.userAgent);
    if (parser.getPlatformType() === 'mobile') {
      warning?.current?.classList.add('rotate-device-warning');
    } else {
      warning?.current?.classList.remove('rotate-device-warning');
    }
    try {
      setSpinner(true);
      fetch(urlList, {
        credentials: 'include',
      }).then((res) => {
        if (res.status === 200) {
          setViews((e) => ({ home: true }));
        } else {
          setViews({ login: true });
        }
      });
    } catch (err) {
      console.log('error z Home get list', err);
      saveConsoleLog(JSON.stringify(`APKA error z Home get list, ${err}`));
    } finally {
      setSpinner(false);
    }
  }, []);

  const install = usePWAInstall();

  return (
    <>
      {deviceInfo === 'iOS' && (
        <PWAPrompt
          isShown={shouldShowPWAPrompt}
          timesToShow={1}
          promptOnVisit={1}
          copyDescription='Aby w pełni korzystać z aplikacji Birthday musisz dodać do Home Screen 😀. Oraz wyrazić zgode na powiadomienia
			Instrukcja poniżej'
        />
      )}
      <div ref={warning} className='chack'>
        <p>
          <b>Mobile users:</b> Prosze obróć urządzenie do orientacji poziomej 😃
        </p>
      </div>
      <div className='App'>
        {install && deviceInfo === ' AndroidOS' && (
          <button onClick={install} className='buttonInstall'>
            Zainstaluj aplikacje BIRTHDAY
          </button>
        )}

        {views.login && <Login setViews={setViews} setMassage={setMassage} setSpinner={setSpinner} />}
        {views.register && <Register setViews={setViews} setSpinner={setSpinner} setMassage={setMassage} />}
        {views.home && <Home setMassage={setMassage} setViews={setViews} setSpinner={setSpinner} />}
        {spinner && <Spinner progress={''} text={'Loading  ...  please wait '} />}
        {massage.text && <Massage type={massage.type} text={massage.text} />}
      </div>
      {/* <span className='buttonInstall'>{deviceInfo} + sprzet</span> */}
      <span className={'stopka'}>© Birthday created by Adibau </span>
    </>
  );
}

export default App;
